<script setup>
import { useEventBus, useI18n } from '#imports'

const { t } = useI18n()
const { on } = useEventBus('message')
const m = useMessage()
on((code, message) => {
  if (+code === 0 || +code === 200) {
    return m.success(t('成功'))
  }
  const k = `fetchCode.${code}`
  m.error(t(k) === k ? message : t(k))
})
</script>

<template>
  <slot />
</template>
